import React from 'react';
import LiteralsService from 'src/services/literals/LiteralsService';
import img1 from 'src/assets/svg/welcomeSlider/Image1.svg';
import img2 from 'src/assets/svg/welcomeSlider/Image2.svg';
import img3 from 'src/assets/png/welcomeSlider/Image3.png';
import img4 from 'src/assets/svg/welcomeSlider/Image4.svg';
import Slider from './Slider';
import Selectors from 'src/utils/selectors';
import { useLocation } from 'react-router';
import adobeTags from 'src/types/adobe-tags';

export default function WelcomeSlider(): JSX.Element {
    const location = useLocation();
    return (
        <Slider
            slides={[
                {
                    img: img1,
                    alt: LiteralsService.getLiteral('WelcomeSlider.alt1'),
                    title: LiteralsService.getLiteral('WelcomeSlider.title1'),
                    mobileContent: LiteralsService.getJsxLiteral('WelcomeSlider.mobileBody1'),
                    nonMobileContent: LiteralsService.getJsxLiteral('WelcomeSlider.body1'),
                    buttonText: LiteralsService.getLiteral('WelcomeSlider.next'),
                    pathname: location.pathname,
                    adobeTags: {
                        close: adobeTags.WelcomeSlider.Slide1.Close,
                        next: adobeTags.WelcomeSlider.Slide1.Next
                    }
                },
                {
                    img: img2,
                    alt: LiteralsService.getLiteral('WelcomeSlider.alt2'),
                    title: LiteralsService.getLiteral('WelcomeSlider.title2'),
                    mobileContent: LiteralsService.getJsxLiteral('WelcomeSlider.mobileBody2'),
                    nonMobileContent: LiteralsService.getJsxLiteral('WelcomeSlider.body2'),
                    buttonText: LiteralsService.getLiteral('WelcomeSlider.next'),
                    pathname: location.pathname,
                    adobeTags: {
                        close: adobeTags.WelcomeSlider.Slide2.Close,
                        next: adobeTags.WelcomeSlider.Slide2.Next
                    }
                },
                {
                    img: img3,
                    alt: LiteralsService.getLiteral('WelcomeSlider.alt3'),
                    title: LiteralsService.getLiteral('WelcomeSlider.title3'),
                    mobileContent: LiteralsService.getJsxLiteral('WelcomeSlider.mobileBody3'),
                    nonMobileContent: LiteralsService.getJsxLiteral('WelcomeSlider.body3'),
                    buttonText: LiteralsService.getLiteral('WelcomeSlider.next'),
                    pathname: location.pathname,
                    adobeTags: {
                        close: adobeTags.WelcomeSlider.Slide3.Close,
                        next: adobeTags.WelcomeSlider.Slide3.Next
                    }
                },
                {
                    img: img4,
                    alt: LiteralsService.getLiteral('WelcomeSlider.alt4'),
                    title: LiteralsService.getLiteral('WelcomeSlider.title4'),
                    mobileContent: LiteralsService.getJsxLiteral('WelcomeSlider.mobileBody4'),
                    nonMobileContent: LiteralsService.getJsxLiteral('WelcomeSlider.body4'),
                    buttonText: LiteralsService.getLiteral('WelcomeSlider.getStarted'),
                    pathname: location.pathname,
                    adobeTags: {
                        close: adobeTags.WelcomeSlider.Slide4.Close,
                        next: adobeTags.WelcomeSlider.Slide4.Next
                    }
                }
            ]}
            data-cy={Selectors.SpendSmart.WELCOME_SLIDER}
        />
    );
}
